import { useMemo } from "react";
import {
  useActorToneColors,
  useEffectiveIsToneColorsEnabled,
} from "@-/dev.improve.haniverse.routes.nav.app._lib.actor.user";
import type { MorphemeTranscription } from "@-/dev.improve.haniverse.lib.morpheme.transcription.entities";
import { toneForPinyin } from "#tone-for-pinyin";

type UseMorphemeTranscriptionOptions = {
  colored?: boolean;
};

export function useMorphemeTranscription(
  pinyin: string,
  { colored = true }: UseMorphemeTranscriptionOptions = {},
): MorphemeTranscription {
  const isToneColorsEnabled = useEffectiveIsToneColorsEnabled();
  const toneColors = useActorToneColors();
  return useMemo(() => {
    const tone = toneForPinyin(pinyin);
    const color = !colored || !isToneColorsEnabled || tone === null ? null : toneColors[tone];
    return { color, pinyin };
  }, [colored, isToneColorsEnabled, pinyin, toneColors]);
}
